export default __webpack_public_path__ + "static/favicon-a207df4999d39e2f82eeebb2fdf5588f.png";